import { render, staticRenderFns } from "./dialog-edit-location.vue?vue&type=template&id=63e5a36a&scoped=true&"
import script from "./dialog-edit-location.vue?vue&type=script&lang=js&"
export * from "./dialog-edit-location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e5a36a",
  null
  
)

export default component.exports